<template>
  <div class="user_info">
    <el-row :gutter="10">

      <el-col :xs="24" :sm="24" :md="7" :lg="7">

        <div class="u_lift">
          <div @dragstart.prevent @click="set_user = true">
            <el-avatar class="u_img_box" :size="72" :src="user_data.avatar || default_img "></el-avatar>
          </div>
          <div class="u_name_box" @click="set_user = true">{{user_data.username || "-"}}</div>
          <div class="change_pwd_box change_pwd_box_kyc" @click="$router.push('/kycManage')">{{$t("bank_card.KYC_Management")}}</div>
          <div class="change_pwd_box" @click="set_user_pwd = true">{{$t("main.text2")}}</div>
        </div>

        <div class="u_lift" style="cursor: pointer">
          <div class="change_pwd_box" @click="open_google_btn">{{$t("main.text693")}}</div>
        </div>

        <div class="u_lift logout_box" @click="log_out_dlg">
            <div @dragstart.prevent>
              <el-avatar class="logout_img_b" :size="24" :src="logout_img"></el-avatar>
            </div>
            {{$t("main.text4")}}
        </div>

      </el-col>
      
      <el-col :xs="24" :sm="24" :md="17" :lg="17">
      <!-- <el-col :xs="24" :sm="24" :md="24" :lg="24"> -->
        <!-- <div class="u_right">
          <div class="r_box">
            <div class="r_box1">
              <div>
                <img v-if="u_img_url" class="dlg_u1" :src="u_img_url" alt="" />
                <img v-else class="r_box3" src="../../assets/img/user.png" alt="" />
              </div>
              <div>
                <div class="r_box4">{{user_data.username}}</div>
                <div class="r_box5">{{user_data.email}}</div>
              </div>
            </div>
            <div class="r_box2">
              <span class="r_box6" @click="set_user = true">{{$t('main.text71')}}</span>
            </div>
          </div>

          <div class="r2_box">
            <div>
              <div class="r_box4 r2_box2">{{$t('main.text2')}}</div>
              <div class="r_box5 r2_box2">{{$t('main.text226')}}</div>
            </div>
            <div>
              <span class="r_box6" @click="set_user_pwd = true">{{$t('main.text71')}}</span>
            </div>
          </div>

        </div> -->
        
        <div class="th_info">
          <div class="th_info_main">
            <div class="th_tit1">{{$t("main.text694")}}</div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("main.text519")}}</div>
              <div class="th_tit4">{{card_info.first_name}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("main.text520")}}</div>
              <div class="th_tit4">{{card_info.last_name}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("main.text524")}}</div>
              <div class="th_tit4">{{card_info.country}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("main.text522")}}</div>
              <div class="th_tit4">{{card_info.date_of_birth}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("main.text185")}}</div>
              <div class="th_tit4">{{card_info.email}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("main.text199")}}</div>
              <div class="th_tit4">+{{card_info.calling_code}} {{card_info.mobile_number}}</div>
            </div>

            <!-- <div class="th_tit1 title_bottom">{{$t("main.text359")}}</div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("main.text683")}}</div>
              <div class="th_tit4">{{card_info.gender}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("main.text290")}}</div>
              <div class="th_tit4">{{card_info.address}}</div>
            </div> -->
            <!-- <div class="th_tit2">
              <div class="th_tit3">&nbsp;</div>
              <div class="th_tit4 edit_btn" @click="edit_addr_btn">{{$t("main.text71")}}</div>
            </div> -->

            <div class="th_tit1 title_bottom">{{$t("beth_text.Residential_address")}}</div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("beth_text.Mail_Address_Line")}}</div>
              <div class="th_tit4">{{card_kyc_address.address||"-"}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("beth_text.Mail_Address_Line2")}}</div>
              <div class="th_tit4">{{card_kyc_address.secondary_address||"-"}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("beth_text.Mail_City")}}</div>
              <div class="th_tit4">{{card_kyc_address.city||"-"}}</div>
            </div><div class="th_tit2">
              <div class="th_tit3">{{$t("beth_text.Mail_State")}}</div>
              <div class="th_tit4">{{card_kyc_address.state||"-"}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("beth_text.Mail_Country")}}</div>
              <div class="th_tit4">{{card_kyc_address.country||"-"}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("main.text199")}}</div>
              <div class="th_tit4">+{{card_kyc_address.calling_code||"-"}} {{card_kyc_address.mobile_number||"-"}}</div>
            </div>

            <div class="th_tit1 title_bottom">{{$t("main.text145")}}</div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("bank_card.Mail_Address_Line")}}</div>
              <div class="th_tit4">{{card_mail_address.address||"-"}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("bank_card.Mail_Address_Line2")}}</div>
              <div class="th_tit4">{{card_mail_address.secondary_address||"-"}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("bank_card.Mail_City")}}</div>
              <div class="th_tit4">{{card_mail_address.city||"-"}}</div>
            </div><div class="th_tit2">
              <div class="th_tit3">{{$t("bank_card.Mail_State")}}</div>
              <div class="th_tit4">{{card_mail_address.state||"-"}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("bank_card.Mail_Country")}}</div>
              <div class="th_tit4">{{card_mail_address.country||"-"}}</div>
            </div>
            <div class="th_tit2">
              <div class="th_tit3">{{$t("main.text199")}}</div>
              <div class="th_tit4">+{{card_mail_address.calling_code||"-"}} {{card_mail_address.mobile_number||"-"}}</div>
            </div>


          </div>
        </div>

      </el-col>
    </el-row>

    <!-- 修改用户信息 -->
    <el-dialog
      :title="$t('main.text234')"
      :visible.sync="set_user"
      custom-class="dlg element_input"
      append-to-body
      center
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <div class="dlg_u_box">
            <div v-loading="aws_s3_loading" element-loading-background="rgba(0, 0, 0, 0.6)">
              <div @dragstart.prevent>
                <el-avatar :size="100" :src="user_data.avatar || default_img "></el-avatar>
              </div>
            </div>
            <div>
              <div>
                <!-- <el-button class="dlg_u2">Choose file</el-button> -->
                <el-upload
                  ref="my-upload"
                  action="#"
                  :limit="1"
                  :show-file-list="false"
                  accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                  :http-request="ossUpload"
                >
                  <el-button class="dlg_u2">{{$t('main.text89')}}</el-button>
                </el-upload>
              </div>
              <div class="dlg_u3">{{$t('main.text235')}}</div>
            </div>
          </div>
          <el-form class="dlg_form" label-position="top">
            <el-form-item :label="$t('main.text83')">
              <el-input v-model="u_name"></el-input>
            </el-form-item>
            <!-- <el-form-item label="Email address">
                        <el-input v-model.trim="u_email"></el-input>
                    </el-form-item> -->
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="set_user = false" class="cancel_btn"
          >{{$t('main.text7')}}</el-button
        >
        <el-button type="primary" class="confirm_btn" @click="u_name_confirm"
          >{{$t('main.text236')}}</el-button
        >
      </span>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog
      :title="$t('main.text2')"
      :visible.sync="set_user_pwd"
      custom-class="dlg element_input"
      append-to-body
      @close="set_pwd_dlg_colse"
      center
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form" label-position="top">
            <el-form-item :label="$t('main.text237')">
              <el-input v-model.trim="old_pwd" :type="pwdType == true ? 'password' : 'text'"></el-input>
              <span class="show-pwd" @click="pwdType = !pwdType">
                <img :src="pwdType ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>
            <el-form-item :label="$t('main.text213')">
              <el-input v-model.trim="pwd" :type="pwdType2 == true ? 'password' : 'text'"></el-input>
              <span class="show-pwd" @click="pwdType2 = !pwdType2">
                <img :src="pwdType2 ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>
            <el-form-item :label="$t('main.text214')">
              <el-input v-model.trim="confirm_pwd" :type="pwdType3 == true ? 'password' : 'text'"></el-input>
              <span class="show-pwd" @click="pwdType3 = !pwdType3">
                <img :src="pwdType3 ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="set_user_pwd = false" class="cancel_btn"
          >{{$t('main.text7')}}</el-button
        >
        <el-button type="primary" @click="u_pwd_confirm" class="confirm_btn"
          >{{$t('main.text36')}}</el-button
        >
      </span>
    </el-dialog>

    <!-- 点击输入密码然后显示二维码和密钥 -->
    <el-dialog
      :visible.sync="set_google_code"
      custom-class="dlg google_code_dlg element_input"
      :show-close="false"
      append-to-body
      center
      width="476px"
    >
      <div class="ewm_box">
        <!-- <div class="ewm_box2">{{$t("main.text674")}}</div> -->
        <div v-if="google_code_num==1">
          <div class="verify_pwd_txt">{{$t("main.text237")}}</div>
          <el-form @submit.native.prevent>
            <el-form-item>
              <el-input v-model="user_pwd" 
              :type="pwdType_google == true ? 'password' : 'text'"
              ></el-input>
              <span class="show-pwd" @click="pwdType_google = !pwdType_google">
                <img :src="pwdType_google ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>
          </el-form>
        </div>
        <div class="ewm_box3" v-if="google_code_num==2">
          <div class="ewm_box1">{{$t("main.text673")}}</div>
          <div class="ewm_box2">{{$t("main.text674")}}</div>
          <div class="ewm_box3">
            <div class="ewm_ody" ref="qrcode1"></div>
          </div>
          <div class="qrcode_secret">
            <!-- <span>{{ google_secret }}</span> -->
            <span>{{ google_secret.substr(0,10) }}</span>
            <span>......</span>
            <span>{{ google_secret.substr(-8,10) }}</span>
            <img src="../../assets/img/copy_icon.png" @click="copy_api(google_secret)" alt="">
          </div>
        </div>
        <!-- <div class="ewm_box4">{{$t("main.text675")}}</div> -->
        <div v-if="google_code_num==1">
          <el-button class="login_btn verify_pwd_btn" @click="set_google_code_next">{{ $t("main.text394") }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 修改地址 -->
    <el-dialog
      :title="$t('main.text695')"
      :visible.sync="set_addr_dlg"
      custom-class="dlg element_input"
      append-to-body
      center
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form" label-position="top">
            <el-form-item :label="$t('main.text696')">
              <el-input v-model="user_addr" type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="upload_tit">
                <div>{{$t("main.text534")}}</div>
                <div>{{$t("main.text543")}}</div>
              </div>
              <el-upload
                class="upload-demo upload_box"
                drag
                :limit="10"
                action="#"
                ref="upload-file"
                :show-file-list="true"
                :file-list="[]"
                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                :http-request="ossUpload_assistant"
                :before-remove="function(file,fileList){child_beforeRemove(file,fileList)}"
                :data="{data_index:1}"
                multiple>
                  <img class="load_icon" src="../../assets/img/user_upload_img.png" alt="">
                  <div class="el-upload__text upload_text">
                    <div>{{$t('main.text88')}}</div>
                    <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                    <div>{{$t('main.text90')}}</div>
                  </div>
              </el-upload>
              
            </el-form-item>

          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="set_addr_dlg = false" class="cancel_btn">
          {{$t('main.text7')}}</el-button>
        <el-button type="primary" class="confirm_btn" @click="dlg_addr_confirm">
          {{$t('main.text36')}}</el-button>
      </span>
    </el-dialog>

    <!-- 修改地址成功 弹框 -->
    <el-dialog
      :visible.sync="add_success_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px">
      <div class="log_out1">
          <img style="width:35px;" src="../../assets/img/dui_icon.png" alt="">
      </div>
      <div class="log_out2 padding1">
        {{$t('main.text537')}}
      </div>
      <div class="log_out3 padding2">
        {{$t('main.text697')}}
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="confirm_btn2" @click="add_success_dlg=false">{{$t('main.text266')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getUserInfo, modify, modifyLoginPassword, awsS3Auth,kyc_submit,verifyLoginPassword} from "@/api/api";
import md5 from "js-md5";
import AWS from "aws-sdk";
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      pwd_yes: require("../../assets/img/eye_no_b.png"),
      pwd_no: require("../../assets/img/eye_yes_b.png"),
      pwdType: true,
      pwdType2: true,
      pwdType3: true,
      set_user: false,
      dlg_form: {},
      set_user_pwd: false,
      dlg_form_pwd: {},

      user_data: "",
      u_img_url: "",
      u_name: "",
      // u_email:'',

      old_pwd: "",
      pwd: "",
      confirm_pwd: "",
      aws_s3_loading:false,
      link_acttive:1,
      old_data:'',
      name_data:'',
      kyc_status:'',
      default_img:require("../../assets/img/default_img.png"),
      logout_img:require("../../assets/img/logout_img.png"),
      card_info:{},
      set_google_code:false,
      set_addr_dlg:false,
      user_addr:'',
      add_success_dlg:false,
      
      card_kyc_address:{},
      card_mail_address:{},
      google_code_num:1,
      user_pwd:"",
      google_secret:"",
      pwdType_google: true,
      
    };
  },

  destroyed(){
    this.bus.$off('open_view_profile_dlg');
    this.bus.$off('open_change_password_dlg');
    sessionStorage.removeItem('top_title_name');
  },
  mounted() {
    sessionStorage.setItem('top_title_name',this.$t('main.text689'));
    this.get_user_info();
    this.bus.$on('open_view_profile_dlg',()=>{
      this.set_user=true;
    });
    this.bus.$on('open_change_password_dlg',()=>{
      this.set_user_pwd=true;
    });
    this.S3Auth();

  },
  methods: {
    get_user_info() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          this.user_data = res.data.data;
          this.card_info = res.data.data.card_info;
          this.old_data = JSON.parse(JSON.stringify(res.data.data));
          this.u_name = res.data.data.username;
          this.u_img_url = res.data.data.avatar;

          this.card_kyc_address = res.data.data.card_kyc_address;
          this.card_mail_address = res.data.data.card_mail_address;

          // console.log(res.data.data);
          // console.log(res.data.data.card_info);
        }
      });
    },
    u_name_confirm() {
      this.set_user = true;
      if (this.u_name == "") {
        // this.$message.closeAll();
        // this.$message.error("Please enter username");
        this.message.ismessage('error',this.$t('main.text203'));
        return false;
      }
      
      if(this.u_name==this.old_data.username){
        this.name_data="";
      }else{
        this.name_data=this.u_name;
      }
      // username	String	用户名
      // avatar	String	头像url
      modify({
        username: this.name_data,
        avatar: '',
      }).then((res) => {
        if (res.data.code == 200) {
          // this.$message.closeAll();
          // this.$message.success("Successfully modified");
          this.message.ismessage('success',this.$t('main.text215'));
          this.set_user = false;
          this.get_user_info();
        } else {
          // this.$message.closeAll();
          // this.$message.error(res.data.msg);
          this.message.ismessage('error',res.data.msg);
        }
      });
    },
    set_pwd_dlg_colse() {
      this.old_pwd = "";
      this.pwd = "";
      this.confirm_pwd = "";
    },
    u_pwd_confirm() {
      if (this.old_pwd == "") {
        // this.$message.closeAll();
        // this.$message.error("Please fill in the password");
        this.message.ismessage('error',this.$t('main.text207'));
        return false;
      }
      if (this.pwd == "") {
        // this.$message.closeAll();
        // this.$message.error("Please fill in a new password");
        this.message.ismessage('error',this.$t('main.text238'));
        return false;
      }
      if (this.confirm_pwd == "") {
        // this.$message.closeAll();
        // this.$message.error("Please fill in the confirm password");
        this.message.ismessage('error',this.$t('main.text208'));
        return false;
      }
      var reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,12}$/;
      if(!reg.test(this.pwd)){
          this.message.ismessage('error',this.$t('main.text246'));
          return false;
      }
      if (this.pwd != this.confirm_pwd) {
        // this.$message.closeAll();
        // this.$message.error("The two passwords do not match, please re-enter");
        this.message.ismessage('error',this.$t('main.text209'));
        return false;
      }

      // old_password	String	当前登录密码 md5
      // password	String	密码 md5
      // confirm_password	String	确认密码 md5
      modifyLoginPassword({
        old_password: md5(this.old_pwd),
        password: md5(this.pwd),
        confirm_password: md5(this.confirm_pwd),
      }).then((res) => {
        if (res.data.code == 200) {
          // this.$message.closeAll();
          // this.$message.success("Successfully modified");
          this.message.ismessage('success',this.$t('main.text215'));
          this.set_user_pwd = false;
          // this.get_user_info();
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("userid");
          this.$router.push("/login");
        } else {
          // this.$message.closeAll();
          // this.$message.error(res.data.msg);
          this.message.ismessage('error',res.data.msg);
        }
      });
    },

    async ossUpload(data) {
      this.aws_s3_loading = true;
      // 上传大小判断
      if (data.file.size / 1000 / 1000 > 5) {
        // this.$message.closeAll();
        // this.$message.error('File size cannot exceed 5M');
        this.message.ismessage('error',this.$t('main.text239'));
        // 上传之后 清空选中的文件 方便下次上传
        setTimeout(() => {
          this.$refs["my-upload"].clearFiles();
        }, 300);
        this.aws_s3_loading = false;
        return false;
      }
      // 类型 判断
      var testmsg = data.file.name.substring(
        data.file.name.lastIndexOf(".") + 1
      );
      const extension =
        testmsg === "jpg" ||
        testmsg === "jpeg" ||
        testmsg === "JPEG" ||
        testmsg === "JPG" ||
        testmsg === "png" ||
        testmsg === "PNG" ||
        testmsg === "bpm" ||
        testmsg === "BPM";
      if (!extension) {
        // this.$message.closeAll();
        // this.$message.error('Wrong file type');
        this.message.ismessage('error',this.$t('main.text240'));
        // 上传之后 清空选中的文件 方便下次上传
        setTimeout(() => {
          this.$refs["my-upload"].clearFiles();
        }, 300);
        this.aws_s3_loading = false;
        return false;
      }
      await this.S3Auth();

      let file_type = data.file.type.split("/")[1];
      const uploadPath ="license/" +  +this.random_16+'.'+file_type;
      let s3 = new AWS.S3();

      let params = {
        Body: data.file,
        Bucket: "data-storage-d3",
        Key: uploadPath,
        ACL: "public-read",
      };

      s3.putObject(params, (err) => {
        if (err) {
          console.log(err);
          console.log(err, err.stack)
          this.aws_s3_loading = false;
          // 上传之后 清空选中的文件 方便下次上传
          setTimeout(() => {
            this.$refs["my-upload"].clearFiles();
          }, 300);
        } else {
          // console.log('success!');
          // console.log(params);
          const url ="https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/" +uploadPath;
          // console.log(url);
          if(params&&url){
            // 上传之后 清空选中的文件 方便下次上传
            setTimeout(() => {
              this.$refs["my-upload"].clearFiles();
            }, 300);

            // 图片上传成功
            modify({
              username: '',
              avatar: url,
            }).then((res) => {
              if (res.data.code == 200) {
                // this.$message.closeAll();
                // this.$message.success("Successfully modified");
                this.message.ismessage('success',this.$t('main.text215'));
                this.aws_s3_loading = false;
                this.set_user = false;
                setTimeout(() => {
                  this.get_user_info();
                  this.bus.$emit("user_data",111);
                  setTimeout(() => {
                    location.reload();
                  }, 0);
                }, 300);
              } else {
                // this.$message.closeAll();
                // this.$message.error(res.data.msg);
                this.message.ismessage('error',res.data.msg);
                this.aws_s3_loading = false;
              }
            });
          }

          
        }
      });
    },
    // 请求aws的配置参数
    async S3Auth() {
      const res = await awsS3Auth();
      if (res.data.code == 200) {
        this.awsS3_data = res.data.data;
        // console.log(this.awsS3_data);
        let current_time = new Date().getTime();
        localStorage.setItem("awss3_token_time", current_time + 3600000 * 10);

        //参数
        AWS.config.update({
          region: "ap-southeast-1",
          credentials: new AWS.CognitoIdentityCredentials({
            IdentityPoolId: this.awsS3_data.IdentityPoolId,
            IdentityId: this.awsS3_data.IdentityId,
            Logins: {
              "cognito-identity.amazonaws.com": this.awsS3_data.Token,
            },
          }),
        });
      }
    },
    service_btn(){
      // console.log(1);
      kyc_submit().then(res=>{
        if(res.data.code==200){
          // this.service_dlg=true;
          this.bus.$emit('kf_dlg');
          // console.log(1);
        }else{
          // this.$message.closeAll();
          // this.$message.error(res.data.msg);
          this.message.ismessage('error',res.data.msg);
        }
      })
    },
    log_out_dlg(){
      this.bus.$emit('open_logout_dlg',true);
    },
    open_google_btn(){
      this.set_google_code=true;
      this.google_code_num=1;
      this.user_pwd="";
    },
    async set_google_code_next(){
      if(!this.user_pwd) return;
      const res = await verifyLoginPassword({password:md5(this.user_pwd)});
      if(!res.data.code==200){
        return this.message.ismessage('error',res.data.msg);
      }
      this.google_secret = res.data.data.google_secret;
      this.google_code_num++;
      if(this.google_code_num>=2){
        this.$nextTick(()=>{
          this.qrcodeRender(this.google_secret);
        })
      }
    },
    qrcodeRender(text) {
      this.$refs.qrcode1.innerHTML = "";
      new QRCode(this.$refs.qrcode1, {
        width: 260,
        height: 260,
        // text: `otpauth://totp/${this.form.email}@${window.location.hostname}?secret=${this.google_secret}`, // 二维码内容
        text: text||"123", // 二维码内容
        colorDark: "#000",//#000 #fff
        colorLight: "#fff",//transparent
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    edit_addr_btn(){
      this.set_addr_dlg=true;
    },
    set_item_url(item_url,index){
        // https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/autonym/3.jpg
        let url=[];
        index;
        // console.log(index,item_url);

        // let text1='https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/autonym/3.jpg';
        // let text2 = text1.split("/");
        // console.log(text1);
        // console.log(text2[4]);
        for (let i = 0; i < item_url.length; i++) {
            let text1=item_url[i];
            let text2=[];
            text2=text1.split("/");
            url.push({name:text2[5],url:text1})
        }
        return url;
    },
    child_beforeRemove(file,fileList,index){
            // console.log(file.name);
            // console.log(fileList);
            // console.log(ind);
            file;fileList;index;
            // for (let j = 0; j < this.corporate_fi[index].url.length; j++) {
            //     // if(this.corporate_fi[ind].uid[j]==file.uid){
            //     if(this.corporate_fi[index].url[j].indexOf(file.name)!=-1){
            //         // console.log(j);
            //         this.child_index_j=j;
            //         break;
            //     }
            // }
            for (let j = 0; j < this.corporate_fi[index].url.length; j++) {
                if(this.corporate_fi[index].url[j].indexOf(file.url)!=-1){
                    this.child_index_j=j;
                    break;
                }
            }

            this.corporate_fi[index].url.splice(this.child_index_j,1);
            this.corporate_fi[index].uid.splice(this.child_index_j,1);


    },
    ossUpload_assistant(data){
            data;
            this.$store.state.aws_loading = true;
            this.show_child=false;
            let file_type = data.file.type.split("/")[1];
            const uploadPath =  'autonym/'+this.createCode()+'/'+this.random_16+'.'+file_type;
            let s3 = new AWS.S3();
            let params = {
                Body: data.file,
                Bucket: "data-storage-d3",
                Key: uploadPath,
                ACL: "public-read",
            };
            s3.putObject(params,(err)=>{
                if(err){
                    console.error('error');
                    console.log(err);
                    console.log(err, err.stack);
                    alert(err, err.stack);
                    this.$store.state.aws_loading=false;
                }else{
                    const url ="https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/" +uploadPath;
                    this.corporate_fi[data.data.data_index].num=data.data.data_index;
                    this.corporate_fi[data.data.data_index].url.push(url);
                    this.corporate_fi[data.data.data_index].uid.push(data.file.uid);
                    this.$store.state.aws_loading=false;
                    this.show_child=true;

                }
            })

    },
    dlg_addr_confirm(){
      this.set_addr_dlg=false;
      this.add_success_dlg=true;
    },
    //复制
    copy_api(v) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", v);
      input.select();
      if (document.execCommand("copy")) {
          document.execCommand("copy");
      }
      document.body.removeChild(input);
      this.message.ismessage('success',this.$t('main.text297'));
    },
    


  },
};
</script>

<style scoped>
/* 滚动条 */
/* .user_info {
  overflow: auto;
  height: calc(100vh - 80px);
}
.user_info::-webkit-scrollbar {
  width: 5px;
}
.user_info::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #687eec;
} */
/* --over-- */

.user_info {
  box-sizing: border-box;
  /* padding: 30px; */
}
.u_lift li {
  box-sizing: border-box;
  padding: 10px 5px;
}
.u_lift li img {
  width: 20px;
  vertical-align: middle;
  margin-top: -2px;
}
.r_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #04182a;
  border-radius: 16px;
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 35px;
  /* cursor: pointer; */
}
.r_box1 {
  display: flex;
  align-items: center;
}
.r_box3 {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  /* border: 2px solid #deb981; */
}
.r_box4 {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #ffffff;
  margin-left: 20px;
  margin-bottom: 4px;
}
.r_box5 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 26px;
  color: #ffffff;
  margin-left: 20px;
  opacity: 0.6;
}
.r_box6 {
  font-size: 15px;
  color: #deb981;
  cursor: pointer;
  margin-right: 20px;
}
.r2_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #04182a;
  border-radius: 16px;
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 35px;
  /* cursor: pointer; */
}
.r2_box2 {
  margin-left: 0;
}
.ref_code {
  margin-top: 22px;
  /* background: #5A6F87; */
  border-radius: 16px;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  background: url(../../assets/img/box_img_bgc.png) #5a6f87 no-repeat;
  background-size: auto 60%;
  background-position: top right;
}

.ref_code2 {
  width: 60px;
}
.ref_code3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 26px;
  margin-left: 16px;
  margin-bottom: 5px;
}
.ref_code4 {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  margin-left: 16px;
}

.dlg_u2,
.dlg_u2:hover {
  background: #00C18E;
  /* box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2); */
  border: none;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: #191E29;
  margin-left: 40px;
  margin-bottom: 8px;
}

.r3_box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #04182a;
  border-radius: 16px;
  /* margin-bottom: 20px; */
  box-sizing: border-box;
  padding: 35px;
  /* padding-bottom: 10px; */
}
.r3_box_padding{
  padding-bottom: 10px;
}
.r3_box_ok{
  background: #12BA9C;
  padding-bottom: 35px;
  color: #fff;
  cursor: pointer;
}
.success_icon{
  width: 22px;
  margin-right: 10px;
  vertical-align: middle;
  margin-top: -3px;
}

.r4_box{
  background: #04182a;
  border-radius: 16px;
  /* margin-bottom: 20px; */
  box-sizing: border-box;
  padding: 35px;
  padding-top: 0;
}
.r4_box1{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #364655;
  padding-top: 10px;
}
/* 退出弹框 */
.log_out1 img{
  width: 40px;
  display: block;
  margin: auto;
}
.log_out2{
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  margin-top: 16px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
}
.log_out3{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.8;
  margin-top: 8px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
}
/* .cancel_btn{
  color: #F1C788;
  border-color: #F1C788;
  background: transparent;
} */
/* .confirm_btn{
  min-width: 86px;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border-color: #F1C788;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  color: #04182A;
  margin-bottom: 15px;
} */
.do_it_later{
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #DEB981;
  text-align: center;
  cursor: pointer;
  margin-bottom: 15px;
}

/* --over-- */
.sh_box{
  width: 155px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  border: 1.5px solid #465D78;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #FFFFFF;
  opacity: 0.6;
}
.sh_box_img{
  width: 23px;
  vertical-align: middle;
  margin-right: 6px;
}
.sh_box_text{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.el-tooltip__popper.is-dark{
  background: #03101C;
}
.jj_sh_box{
  border-color: #F35F65;
  color: #F35F65;
  width: 120px;
}
.u_right{
  max-width: 92%;
  margin: auto;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}
.u_lift{
  background: #232A36;
  border-radius: 16px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  box-sizing: border-box;
  padding: 22px 23px;
  margin-bottom: 20px;
}
.u_img_box{
  margin-bottom: 20px;
  cursor: pointer;
}
.u_name_box{
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 8px;
  cursor: pointer;
}
.change_pwd_box{
  line-height: 18px;
  color: #00C18E;
  cursor: pointer;
}
.change_pwd_box_kyc{
  line-height: 18px;
  color: #00C18E;
  cursor: pointer;
  margin-bottom: 3px;
  margin: 14px 0 8px;
}
.logout_box{
  color: #FF6363;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.logout_img_b{
  margin-right: 12px;
  background: transparent;
  vertical-align: middle;
}

/* 右侧 css */
.th_info{
    background: #232A36;
    border-radius: 16px;
}
.th_info_top{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1.5px solid #191E29;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
}
.th_info_main{
    box-sizing: border-box;
    padding: 28px;
}
.th_tit1{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 12px;
}
.th_tit2{
    margin-bottom: 12px;
    display: flex;
}
.th_info_main .th_tit2:last-child{
    margin-bottom: 0;
}
.th_tit3{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    width: 160px;
    margin-right: 28px;
    display: inline-block;
}
.th_tit4{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    display: inline-block;
}
.title_bottom{
    margin-top: 30px;
}
/* ------ */
.ewm_box{
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: #FFFFFF;
  box-sizing: border-box;
  padding: 28px;
}
.ewm_box1{
  font-weight: 700;
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 8px;
}
.ewm_box2{
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
  margin-bottom: 28px;
}
.ewm_box4{
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
  margin: 28px 0;
  word-break: break-word;
}
.ewm_ody{
  display: inline-block;
}
.login_btn,
.login_btn:hover {
  width: 100%;
  height: 42px;
  background: #00C18E;
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-color: #00C18E;
  border-radius: 4px;
  color: #191E29;
  /* margin-top: 10px; */
  font-size: 15px;
}
.edit_btn{
  cursor: pointer;
  color: #00C18E;
}
.upload_box >>> .el-upload{
    width: 100%;
}
.upload_box >>> .el-upload-dragger{
  background: #333A47;
  border: 1.5px dashed rgba(255, 255, 255, 0.4);
  border-radius: 4px;
  width: 100%;
  height: 190px;
}
.icon_upload{
    margin: 10px auto 0;
    font-size: 50px;
}
.upload_text div{
    line-height: initial;
    color: rgba(255, 255, 255, 0.6);
}
.upload_btn{
    border-color: #00C18E;
    background: #00C18E;
    border-radius: 4px;
    font-weight: bold;
    font-size: 15px;
    /* line-height: 18px; */
    color: #191E29;
    margin: 12px auto;
    height: 38px;
}
.load_icon{
    width: 30px;
    vertical-align: middle;
    margin-top: 25px;
    margin-bottom: 10px;
}
.upload_tit{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
  margin-bottom: 12px;
  word-break: break-word;
}
.verify_pwd_txt{
  color: #fff;
  text-align: center;
  margin-bottom: 20px;
}
.verify_pwd_btn{
  margin-top: 20px;
}
/* ---- */
.qrcode_secret{
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
  margin: 28px 0;
}
.qrcode_secret span{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 68%;
  display: inline-block;
}
.qrcode_secret img{
  cursor: pointer;
  margin-left: 5px;
  width: 15px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}

</style>

<style>
/* .dlg {
  background: rgb(4, 23, 40) !important;
  color: #fff;
}
.dlg .el-dialog__title {
  color: #fff;
}
.dlg .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.dlg .el-dialog__body {
  padding: 30px 0;
}
.element_input .el-input__inner{
  background: #223C58;
  border-color: #223C58;
  color: #fff;
} */

/* ------ */
.google_code_dlg .el-dialog__body,
.google_code_dlg .el-dialog__header{
  padding: 0 !important;
}




</style>

<style scoped>
@media screen and (max-width: 850px) {
  .r_box,.r2_box,.r3_box,.r4_box{
    padding: 15px;
  }
  .dlg_u1 {
    width: 70px;
    height: 70px;
  }
  .r3_box,.r4_box,.r4_box1{
    display: block;
  }
  .dlg_u_box{
    justify-content: center;
  }
  .dlg_form {
    margin: auto;
    margin-top: 25px;
    width: 80%;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .r_box3{
    width: 65px;
    height: 65px;
  }


}
</style>